import React from 'react';
import { Link } from 'react-router-dom';

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src="/logo.jpeg" alt="Zinex Softwares" className="footer-logo" />
            <p>Genuine software licenses, private or shared, delivered by email within minutes of payment.</p>
          </div>
          <div className="footer-col">
            <h4>Shop</h4>
            <Link to="/products">All licenses</Link>
            <Link to="/cart">Your cart</Link>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <Link to="/about">About us</Link>
          </div>
          <div className="footer-col">
            <h4>Payments accepted</h4>
            <p className="payment-badges">Paystack &middot; Squad by GTCO</p>
          </div>
        </div>
        <div className="footer-bottom">
          &copy; {new Date().getFullYear()} Zinex Softwares. All rights reserved.
        </div>
      </footer>
    );
  }
}

export default Footer;
